<template>
  <div class="navbar-container">
    <p class="navbar-item"
      :class="{ 'navbar-item__active': selectedNav.includes(r.routing), 'navbar-item__game': r.isGame }"
      v-for="(r, index) in routings" :key="index" @click="goToPage(r)">
      {{ r.name }}
    </p>
  </div>
</template>
<script>
import languageMixins from "@/mixins/language-mixins";

export default {
  mixins: [languageMixins],
  data() {
    return {
      routings: [],
      selectedNav: '',
    }
  },
  created() {
    this.selectedNav = window.location.pathname
    this.handleInitRouting()
  },
  watch: {
    // Coupons mounts this bar before games-markets returns. Rebuild when it lands
    // so the game links are not stuck missing after the rest of the page renders.
    "$store.state.gameMarket"() {
      this.handleInitRouting()
    },
  },
  methods: {
    handleInitRouting() {
      const routing = [
        {
          name: this.getTranslatedText("saved numbers"),
          routing: "/my-numbers"
        },
        {
          name: this.getTranslatedText("my bets"),
          routing: "/my-bets"
        },
        {
          name: this.getTranslatedText("results stats"),
          routing: "/lastest-results",
        },
        {
          name: this.getTranslatedText("payouts"),
          routing: "/payouts"
        },
      ]
      const games = (this.$store.state.gameMarket || []).map(game => {
        return {
          name: game.name,
          routing: `/coupons/${game.slug}`,
          isGame: true,
          gameSlug: game.slug
        };
      });

      this.routings = [...games, ...routing]
    },

    goToPage(r) {
      if (this.$route.path == r.routing) return;
      this.selectedNav = r.routing;
      var path = r.routing;

      const query = this.$route.query;
      this.$router.push({ path: path, query });
      this.$store.commit("setMarketSelected", null)

      if (this.$store.state.isScreenMobile) {
        //scroll to center
        setTimeout(() => {
          let item = document.querySelector('.navbar-item__active')
          if (item) {
            item.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'center',
            });
          }
        }, 100);
      }
      //

    },
  }
}
</script>
<style lang="scss">
@import "@/public/scss/common/header/navbar.scss";
</style>
